import styled from '@emotion/styled'
import { colors } from '../../../__styling/settings/colors'
import { fonts } from '../../../__styling/settings/fonts'
import { FontScales } from '../../../__styling/settings/fontScale'
import { calcRem } from '../../../__styling/style-functions/calc-rem'
import { themedValue } from '../../../__styling/themed-value'
import { SectionOverride } from '../SectionHeader'

export interface SectionHeaderContainer {
    section: SectionOverride
}

export const StyledSimpleSectionHeadingContainer = styled(
    'div',
)<SectionHeaderContainer>(
    {
        display: 'flex',
        flex: '1 0 auto',
        alignContent: 'center',
    },
    ({ section }) => ({
        borderBottom:
            section === 'inline-content-cng'
                ? `4px solid ${colors.perthnow.blueCerulean}`
                : `4px solid ${colors.perthnow.greyCoal}`,
    }),
)

export interface StyledHeadingProps {
    fontScale: FontScales | undefined
    section: SectionOverride
}

export const StyledSimpleHeading = styled('h2')<StyledHeadingProps>(
    {
        lineHeight: 1,
        textTransform: 'uppercase',
    },
    ({ theme, fontScale, section }) => ({
        color:
            section === 'inline-content-cng'
                ? colors.perthnow.blueCerulean
                : colors.perthnow.greyCoal,
        margin: calcRem(0, 0, theme.margins.xs, 0),
        fontFamily: themedValue(theme, {
            thewest: fonts.thewest.sansSerif,
            fallback: theme.fonts.heading,
        }),
        fontSize: themedValue(theme, {
            thewest: fontScale
                ? calcRem(Math.ceil(18 * fontScale))
                : calcRem(24),
            perthnow: fontScale
                ? calcRem(Math.ceil(18 * fontScale))
                : calcRem(24),
            sevennews: fontScale
                ? calcRem(Math.ceil(18 * fontScale))
                : calcRem(22),
            fallback: undefined,
        }),
    }),
)
